// extracted by mini-css-extract-plugin
export default {"container":"CopySignature_container__tlLlI"};